export default "__VITE_ASSET__Cjf5g_sT__"